<template>
  <div ref="DOM" class="selectCityMain">
    <div ref="Box">
      <!--      <div v-if="letter.length > 0" class="now-sort">{{letter}}</div>-->
      <!--      <div :class="['now-letter', fadeFlag?'fadeIn':'']">{{letter}}</div>-->

      <!--      <div class="letterBox">-->
      <!--        <p v-for="(item,idx) in firstList" :key="idx" :class="idx === activtIndex?'active':''"-->
      <!--           @click="scrollSelect(idx)">{{ item.first }}</p>-->
      <!--      </div>-->

      <div>
        <!--        <div class="hostCityBox">-->
        <!--          <div-->
        <!--              class="base-wrap"-->
        <!--              v-for="(item, index) in quickPanelData"-->
        <!--              :classesAttr="item"-->
        <!--              :key="index"-->
        <!--          >-->
        <!--            <div class="title">{{item.title}}</div>-->
        <!--            <div class="panel host" ref="host">-->
        <!--              <span-->
        <!--                  class="item"-->
        <!--                  v-for="(cy,idx) in item.data"-->
        <!--                  :key="idx"-->
        <!--                  @click="selectCity(cy)"-->
        <!--              >{{cy}}</span>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->


        <div class="cityListBox">
          <div v-for="(item,index) in cityList" :key="index" class="base-wrap">
            <div class="title">{{ item.first }}</div>
            <div class="panel">
              <p
                  v-for="(city,idx1) in item.list"
                  :key="idx1"
                  class="cityName"
                  @click="selectCity(city)"
              >{{ city.cityName }}</p>
            </div>
          </div>
        </div>


      </div>
    </div>

    <div class="ad-btm"></div>
  </div>
</template>

<script>
import {cityList,firstList} from "../utils/city.js"

export default {
  name: "city",
  data() {
    return {
      cityList,
      firstList,
      activtIndex:0,


      letter:"",
      fadeFlag: false,
      scrolly: 0,
      city:{},
    }
  },
  mounted() {
    //window.addEventListener("scroll", this.handleScroll, true);
  },
  // destroyed(){
  //   bus.$emit('changeCity', this.city)
  // },
  methods: {
    handleScroll() {
      var scrollTop = document.documentElement.scrollTop;
    },
    //计算滚动条滚动的距离
    scrollSelect(index) {
      this.letter = this.letterList[index];
      this.fadeFlag = true;
      this.activtIndex = index;
      this.Timer = setTimeout(() => {
        this.fadeFlag = false;
      }, 1000);
      let scrolly = 0;
      //热门城市自适应高度获取元素的高度
      let hostHeight = document.getElementsByClassName("host")[1].offsetHeight;
      let topHeght = 132 + hostHeight;
      if (index === 0) {
        this.scrolly = 0;
      } else if (index === 1) {
        this.scrolly = 92;
      } else if (index === 2) {
        this.scrolly = topHeght;
      } else if (index >= 3) {
        let len = 0;
        this.cityList.forEach((item, idx) => {
          if (idx < index - 2) {
            len += item.list.length;
          }
        });
        this.scrolly = topHeght + (index - 2) * 40.8 + len * 35;
      }
      document.documentElement.scrollTop = this.scrolly;
    },


    //点击选择城市
    selectCity(city) {
      //console.log(city,'city')
      //this.city = city
      localStorage.setItem('city',JSON.stringify(city))
      this.$router.push({ path: "/" });
    },




  }
}
</script>

<style lang="less" scoped>
.selectCityMain {
  width: 100%;
  // height: 500px;
  // height: 100%;
  overflow-y: auto;
  position: relative;

  .letterBox {
    width: 35px;
    position: fixed;
    top: 18%;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 16px;
    padding: 10px 0;

    p {
      font-size: 12px;
      color: #fff;
      text-align: center;
      padding-bottom: 3px;
    }

    .active {
      background: rgba(0, 0, 0, 0.5);
    }
  }

  .now-letter {
    font-size: 60px;
    color: #ccc;
    position: fixed;
    top: 60%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    opacity: 0;

    &.fadeIn {
      animation: fade 1s linear 0ms;
      opacity: 1;
    }
  }

  .now-sort {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    font-size: 14px;
    padding: 10px;
    background: #ccc;
  }

  .hostCityBox {
    width: 100%;

    .base-wrap {
      overflow: hidden;

      .title {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        font-size: 14px;
        padding: 10px;
        background: #ccc;
      }

      .panel {
        display: flex;
        flex-wrap: wrap;
        font-size: 14px;
        padding: 10px;
        padding-right: 30px;

        .item {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 74px;
          border: 1px solid;
          border-radius: 10px;
          margin-bottom: 10px;
          margin-right: 8px;
        }

        &::after {
          display: block;
          content: "";
          width: 200px;
          border: 1px solid transparent;
        }
      }
    }
  }

  .cityListBox {
    width: 100%;

    .title {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      font-size: 14px;
      padding: 10px;
      background: #F1F1F1;
    }

    .panel {
      display: flex;
      flex-wrap: wrap;
      font-size: 14px;
      padding: 0 10px;
      padding-right: 30px;

      .cityName {
        font-size: 14px;
        width: 100%;
        height: 35px;
        display: flex;
        align-items: center;
      }
    }
  }
}
.ad-btm{
  height: 100px;
}
</style>